import { useState, useCallback, useEffect, useRef } from "react";
import { listReportRequests } from "../api/inform";

const ACTIVE_POLL_MS = 5000;
const IDLE_POLL_MS = 20000;

export default function useReportRequestPolling({ page = 1, limit = 30 } = {}) {
  const [requests, setRequests] = useState([]);
  const [loadingList, setLoadingList] = useState(true);
  const timeoutRef = useRef(null);
  const mountedRef = useRef(true);
  const pollRef = useRef(null);

  useEffect(() => {
    mountedRef.current = true;

    const poll = async () => {
      try {
        const result = await listReportRequests({ page, limit });
        if (!mountedRef.current) return;

        let data = [];
        if (!result?.error) {
          data = result?.data || [];
          setRequests(data);
        }
        setLoadingList(false);

        const hasActive = data.some(
          (r) => r.status === "queued" || r.status === "processing",
        );
        const delay = hasActive ? ACTIVE_POLL_MS : IDLE_POLL_MS;
        timeoutRef.current = setTimeout(poll, delay);
      } catch {
        if (!mountedRef.current) return;
        setLoadingList(false);
        timeoutRef.current = setTimeout(poll, IDLE_POLL_MS);
      }
    };

    pollRef.current = poll;
    poll();

    return () => {
      mountedRef.current = false;
      clearTimeout(timeoutRef.current);
    };
  }, [page, limit]);

  const refetch = useCallback(() => {
    clearTimeout(timeoutRef.current);
    if (pollRef.current) pollRef.current();
  }, []);

  return { requests, loadingList, refetch };
}
